import React from "react";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";

import Div from "@components/Div";
import { H4 } from "@components/Heading";
import { Text, TextMediumWeight } from "@components/Text";

import { EMAIL_TYPE } from "@utils/enum";
import { formatDateAndTime } from "@utils/utils";

import {
  EMAIL_LABELS,
  IS_SECURE_EMAIL,
  EMAIL_CLASSIFICATION,
} from "./EmailHeader.constants";

const EmailHeader = ({
  created_at,
  direction,
  status,
  from,
  to,
  subject,
  is_secure_email,
  email_reply_classification,
}) => {
  const { formatMessage, messages } = useIntl();

  const shouldShowSecureFields = direction === EMAIL_TYPE.INCOMING;

  const getEmailLabel = (direction, status) => {
    if (direction === EMAIL_TYPE.OUTGOING && status === "failed") {
      return messages.label_error_while_ending;
    }
    return EMAIL_LABELS[direction];
  };

  return (
    <Div display="flex" flexDirection="column" gridGap={3}>
      <Div display="flex" alignItems="center" gridGap={2}>
        <H4>{formatDateAndTime(created_at)}</H4>
        <Div
          display="flex"
          alignItems="center"
          backgroundColor="var(--grey-lightest)"
          borderRadius="8px"
          px={2}
          py={1}
        >
          <TextMediumWeight fontSize="var(--fs-text-small)">
            {getEmailLabel(direction, status)}
          </TextMediumWeight>
        </Div>
      </Div>

      <Div display="flex" flexDirection="column" gridGap={2}>
        <Div display="flex" flexDirection="column" gridGap={3}>
          <Div display="flex" gridGap={1}>
            <TextMediumWeight>{`${formatMessage({ id: "filter_date_from" })}:`}</TextMediumWeight>
            <Text>{from}</Text>
          </Div>

          <Div display="flex" gridGap={1}>
            <TextMediumWeight>{`${formatMessage({ id: "filter_date_to" })}:`}</TextMediumWeight>
            <Text>{to}</Text>
          </Div>

          <Div display="flex" gridGap={1}>
            <TextMediumWeight>{`${formatMessage({ id: "label_subject" })}:`}</TextMediumWeight>
            <Text>{subject}</Text>
          </Div>

          {shouldShowSecureFields && (
            <>
              <Div display="flex" gridGap={1}>
                <TextMediumWeight>{`${formatMessage({ id: "label_secure_email" })}:`}</TextMediumWeight>
                <Text>{IS_SECURE_EMAIL[is_secure_email]}</Text>
              </Div>

              <Div display="flex" gridGap={1}>
                <TextMediumWeight>{`${formatMessage({ id: "label_email_classification" })}:`}</TextMediumWeight>
                <Text>{EMAIL_CLASSIFICATION[email_reply_classification]}</Text>
              </Div>
            </>
          )}
        </Div>
      </Div>
    </Div>
  );
};

EmailHeader.propTypes = {
  created_at: PropTypes.string,
  direction: PropTypes.string,
  status: PropTypes.string,
  from: PropTypes.string,
  to: PropTypes.string,
  subject: PropTypes.string,
  is_secure_email: PropTypes.bool,
  email_reply_classification: PropTypes.string,
};

export default EmailHeader;
